import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstance3e78m6vf98i66 as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.key_1 = key;
        this.value_1 = value;
      }
      get_key_18j28a_k$() {
        return this.key_1;
      }
      get_value_j01efc_k$() {
        return this.value_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.key_1) + ', value=' + toString(this.value_1) + ')';
      }
      hashCode() {
        var result = this.key_1 == null ? 0 : hashCode(this.key_1);
        result = imul(result, 31) + (this.value_1 == null ? 0 : hashCode(this.value_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        if (!equals(this.key_1, other.key_1))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.descriptor_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.element$default_ey7ac9_k$('key', keySerializer.get_descriptor_wjt6a0_k$());
          $this$buildSerialDescriptor.element$default_ey7ac9_k$('value', valueSerializer.get_descriptor_wjt6a0_k$());
          return Unit_instance;
        });
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      get_key_xxv71t_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_key_18j28a_k$();
      }
      get_key_ebxj0t_k$(_this__u8e3s4) {
        return this.get_key_xxv71t_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      get_value_ubwxlt_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_value_j01efc_k$();
      }
      get_value_k1nl8b_k$(_this__u8e3s4) {
        return this.get_value_ubwxlt_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_8m84pf_k$(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.descriptor_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('first', keySerializer.get_descriptor_wjt6a0_k$());
          $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('second', valueSerializer.get_descriptor_wjt6a0_k$());
          return Unit_instance;
        });
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      get_key_a9cqdk_k$(_this__u8e3s4) {
        return _this__u8e3s4.first_1;
      }
      get_key_ebxj0t_k$(_this__u8e3s4) {
        return this.get_key_a9cqdk_k$(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      get_value_8k5bza_k$(_this__u8e3s4) {
        return _this__u8e3s4.second_1;
      }
      get_value_k1nl8b_k$(_this__u8e3s4) {
        return this.get_value_8k5bza_k$(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_8m84pf_k$(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.decodeSerializableElement$default_j0zaoi_k$($this.descriptor_1, 0, $this.aSerializer_1);
  var b = composite.decodeSerializableElement$default_j0zaoi_k$($this.descriptor_1, 1, $this.bSerializer_1);
  var c = composite.decodeSerializableElement$default_j0zaoi_k$($this.descriptor_1, 2, $this.cSerializer_1);
  composite.endStructure_1xqz0n_k$($this.descriptor_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.decodeElementIndex_bstkhp_k$($this.descriptor_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.decodeSerializableElement$default_j0zaoi_k$($this.descriptor_1, 0, $this.aSerializer_1);
        break;
      case 1:
        b = composite.decodeSerializableElement$default_j0zaoi_k$($this.descriptor_1, 1, $this.bSerializer_1);
        break;
      case 2:
        c = composite.decodeSerializableElement$default_j0zaoi_k$($this.descriptor_1, 2, $this.cSerializer_1);
        break;
      default:
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Unexpected index ' + index);
    }
  }
  composite.endStructure_1xqz0n_k$($this.descriptor_1);
  if (a === get_NULL())
    throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Element 'third' is missing");
  return new (Triple())(a, b, c);
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.aSerializer_1 = aSerializer;
        this.bSerializer_1 = bSerializer;
        this.cSerializer_1 = cSerializer;
        var tmp = this;
        tmp.descriptor_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('first', this.aSerializer_1.get_descriptor_wjt6a0_k$());
          $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('second', this.bSerializer_1.get_descriptor_wjt6a0_k$());
          $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('third', this.cSerializer_1.get_descriptor_wjt6a0_k$());
          return Unit_instance;
        });
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_jqf7mm_k$(encoder, value) {
        var structuredEncoder = encoder.beginStructure_yljocp_k$(this.descriptor_1);
        structuredEncoder.encodeSerializableElement_isqxcl_k$(this.descriptor_1, 0, this.aSerializer_1, value.first_1);
        structuredEncoder.encodeSerializableElement_isqxcl_k$(this.descriptor_1, 1, this.bSerializer_1, value.second_1);
        structuredEncoder.encodeSerializableElement_isqxcl_k$(this.descriptor_1, 2, this.cSerializer_1, value.third_1);
        structuredEncoder.endStructure_1xqz0n_k$(this.descriptor_1);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_jqf7mm_k$(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var composite = decoder.beginStructure_yljocp_k$(this.descriptor_1);
        if (composite.decodeSequentially_xlblqy_k$()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.keySerializer_1 = keySerializer;
        this.valueSerializer_1 = valueSerializer;
      }
      serialize_hmir9w_k$(encoder, value) {
        var structuredEncoder = encoder.beginStructure_yljocp_k$(this.get_descriptor_wjt6a0_k$());
        structuredEncoder.encodeSerializableElement_isqxcl_k$(this.get_descriptor_wjt6a0_k$(), 0, this.keySerializer_1, this.get_key_ebxj0t_k$(value));
        structuredEncoder.encodeSerializableElement_isqxcl_k$(this.get_descriptor_wjt6a0_k$(), 1, this.valueSerializer_1, this.get_value_k1nl8b_k$(value));
        structuredEncoder.endStructure_1xqz0n_k$(this.get_descriptor_wjt6a0_k$());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_hmir9w_k$(encoder, value);
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        var tmp$ret$1;
        $l$block: {
          if (composite.decodeSequentially_xlblqy_k$()) {
            var key = composite.decodeSerializableElement$default_j0zaoi_k$(this.get_descriptor_wjt6a0_k$(), 0, this.keySerializer_1);
            var value = composite.decodeSerializableElement$default_j0zaoi_k$(this.get_descriptor_wjt6a0_k$(), 1, this.valueSerializer_1);
            tmp$ret$1 = this.toResult_8m84pf_k$(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.decodeElementIndex_bstkhp_k$(this.get_descriptor_wjt6a0_k$());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.decodeSerializableElement$default_j0zaoi_k$(this.get_descriptor_wjt6a0_k$(), 0, this.keySerializer_1);
                break;
              case 1:
                value_0 = composite.decodeSerializableElement$default_j0zaoi_k$(this.get_descriptor_wjt6a0_k$(), 1, this.valueSerializer_1);
                break;
              default:
                throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Element 'value' is missing");
          tmp$ret$1 = this.toResult_8m84pf_k$(key_0, value_0);
        }
        var result = tmp$ret$1;
        composite.endStructure_1xqz0n_k$(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
